import styled from "styled-components";
import { Icon as IconElement, Heading, Paragraph } from "react-ui-kit";
import { transparentize } from "polished";
import RContainer from "../../components/ResponsiveContainer";
import { TLogoStyles } from "../../@types/component/TFooterComponent";

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.secundary};
  color: ${({ theme }) => theme.colors.textInSecundaryColor};
  margin-top: auto;
`;

export const ResponsiveContainer = styled(RContainer)``;

export const PartnerLogo = styled.img.attrs((props: TLogoStyles) => ({
  src: typeof props.img === "string" ? props.img : props.img.url,
}))<TLogoStyles>`
  width: ${({ img }) => (typeof img === "string" ? "124px" : img.width)};
  height: ${({ img }) => (typeof img === "string" ? "40px" : img.height)};
`;

export const H3 = styled(Heading).attrs({
  type: "h3",
})`
  font-size: 18px;
`;
export const P = styled(Paragraph)``;

export const SocialContainer = styled.div`
  display: flex;
  margin-top: 32px;
`;

export const SocialCircle = styled.div`
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.icon};
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 7px;

  i {
    color: ${({ theme }) => theme.colors.icon};
  }
`;

export const Icon = styled(IconElement)``;

export const TopContainer = styled.div`
  padding: 45px 36px 30px 36px;
  display: flex;
  justify-content: center;
`;

export const InfoContainer = styled.div`
  display: flex;
  justify-content: center;
  border-top: 1px solid ${({ theme }) => transparentize(0.7, theme.colors.icon)};
  padding: 36px;

  p:nth-child(1) {
    font-weight: bold;
    margin-bottom: 2px;
  }

  p:nth-child(1) {
    font-weight: bold;
    margin-bottom: 2px;
  }
`;
